import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

// Your Firebase configuration object
// You'll need to replace these values with your actual Firebase project config
//
// IMPORTANT: This config determines which environment (dev/prod) the app uses
// - Production project: stoiccredit-64fff
// - Development project: Create a new Firebase project for dev

export const firebaseConfig = {
  apiKey: "AIzaSyBTozCZxP91xzxgVcoUOXFDURSqd92X_uQ",
  authDomain: "stoiccredit-64fff.firebaseapp.com",
  projectId: "stoiccredit-64fff",
  storageBucket: "stoiccredit-64fff.firebasestorage.app",
  messagingSenderId: "234376920064",
  appId: "1:234376920064:web:76a18e98e0c0a3f242ece5",
  measurementId: "G-SCXHTNLX7J",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check
// Replace 'your-recaptcha-site-key' with your actual reCAPTCHA v3 site key
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6Lfi8YYrAAAAAJDIJZJDO5wLbTsLLmTjWDS8mLY_"),
  isTokenAutoRefreshEnabled: true,
});

// Development bypass for App Check (only in development)
if (process.env.NODE_ENV === "development") {
  // @ts-ignore
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== "undefined") {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn("Firebase Analytics initialization failed:", error);
  }
}
export { analytics };

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});

export default app;
